import React from 'react';

const UserStats = ({ users }) => {
  const stats = [
    { label: 'Total Users', value: users?.length || 0, color: 'text-gray-500' },
    { label: 'Active', value: users?.filter(m => m.status === 'ACTIVE').length || 0, color: 'text-green-500' },
    { label: 'Inactive', value: users?.filter(m => m.status !== 'ACTIVE').length || 0, color: 'text-red-400' },
    { label: 'Departments', value: new Set(users?.map(u => u.user_department)).size || 0, color: 'text-blue-200' },
  ];

  return (
    <div className="grid grid-cols-2 gap-2 mb-3 sm:mb-5 sm:gap-3 md:grid-cols-4">
      {stats.map(({ label, value, color }) => (
        <div key={label} className="p-3 bg-gray-100 border border-gray-300 sm:p-4 dark:bg-richblue-600/20 dark:border-blue-700/80 rounded-xl">
          <p className="text-[11px] sm:text-sm text-blue-400 dark:text-blue-300">{label}</p>
          <p className={`mt-1 text-xl sm:text-2xl font-bold ${color}`}>{value}</p>
        </div>
      ))}
    </div>
  );
};

export default UserStats;

